export const DATE_FORMATS = Object.freeze({
  'yyyy-MM-dd': 'yyyy-MM-dd',
  ISO: "yyyy-MM-dd'T'HH:mm:ss",
  TIME: 'HH:mm:ss',
  yyMMdd: 'yyMMdd',
})
